import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { toast, Button } from '@grandvisionhq/common';
import { Form, Text, Util, Email } from '@grandvisionhq/forms';
import { useFormatter, useLocation } from '@grandvisionhq/frk-routing';
import { sha256 } from '@grandvisionhq/lib-utils-w3c';
import { useIntl } from '@grandvisionhq/state';
import { useLogin } from '../../hooks/use-login.js';
import ErrorMessagesContainer from '../ErrorMessages/ErrorMessagesContainer.js';

const LoginForm = ()=>{
    const [email1, setEmail] = React.useState();
    const [orderNumber1, setOrderNumber] = React.useState();
    const [isRedirecting, setIsRedirecting] = React.useState(false);
    const { getLabel  } = useIntl();
    const formatter = useFormatter();
    const { push  } = useLocation();
    const onError = React.useCallback(()=>{
        toast.failed('returns.errors.fetchError');
    }, []);
    const onCompleted = React.useCallback((result)=>{
        var ref;
        const hasNoFailures = !!!result.getReturn.failures.length;
        const isReturnable = ((ref = result.getReturn.return) === null || ref === void 0 ? void 0 : ref.status) === 'RETURNABLE';
        if (hasNoFailures && isReturnable) {
            setIsRedirecting(true);
            push(formatter({
                route: 'returns.select-items',
                params: {
                    email: email1,
                    orderNumber: orderNumber1
                }
            }));
        }
    }, [
        email1,
        formatter,
        orderNumber1,
        push
    ]);
    const [trigger, { loading: fetchIsLoading  }] = useLogin({
        onError,
        onCompleted
    });
    const handleSubmit = React.useCallback(function() {
        var _ref = swcHelpers.asyncToGenerator(function*({ formState  }) {
            if (formState.orderNumber && formState.email) {
                try {
                    /*
            Hash the customer's email for security before using it in the returns flow.
            This ensures sensitive information is not directly exposed in URLs or APIs.
            Additionally, the email is "normalized" by converting it to lowercase before hashing,
            as the backend performs the same normalization before creating the hash.
          */ const email = yield sha256(formState.email.value.toLowerCase());
                    const orderNumber = formState.orderNumber.value;
                    setOrderNumber(orderNumber);
                    if (email) {
                        setEmail(email);
                        trigger({
                            email,
                            orderNumber
                        });
                    }
                } catch (error) {
                    console.error('Failed to hash email:', error);
                    toast.failed('returns.errors.fetchError');
                }
            }
        });
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        trigger
    ]);
    const loading = fetchIsLoading || isRedirecting;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ErrorMessagesContainer, null), /*#__PURE__*/ React.createElement(Form, {
        className: "returns-login-form",
        name: "returns-login-form",
        onSubmit: handleSubmit
    }, /*#__PURE__*/ React.createElement(Text, {
        id: "orderNumber",
        "data-t": "order-number",
        validations: [
            Util.validations.isOrderNumber
        ],
        label: getLabel('returns.page.login.field.orderNumber'),
        errorMessage: getLabel('returns.page.login.field.orderNumber.errorMessage'),
        disabled: isRedirecting
    }), /*#__PURE__*/ React.createElement(Email, {
        id: "email",
        label: getLabel('returns.page.login.field.email'),
        errorMessage: getLabel('returns.page.login.field.email.errorMessage'),
        disabled: isRedirecting
    }), /*#__PURE__*/ React.createElement(Button, {
        caption: getLabel('returns.page.login.action.submit'),
        className: "returns-login-form__submit",
        isLoading: loading,
        type: "submit",
        disabled: loading
    })));
};

export { LoginForm as default };
//# sourceMappingURL=LoginForm.js.map
